import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyAz2IAeuM6yfY_6YlsR1anDUHfmFOkLR2s",
  authDomain: "round-count-3dacd.firebaseapp.com",
  databaseURL: "https://round-count-3dacd.firebaseio.com",
  projectId: "round-count-3dacd",
  storageBucket: "round-count-3dacd.appspot.com",
  messagingSenderId: "599138688889",
  appId: "1:599138688889:web:57f3503a669861c604d9a8",
  measurementId: "G-HGFYQ0QNP1"
};
firebase.initializeApp(firebaseConfig)

// utils
const fb_db = firebase.firestore()
const fb_auth = firebase.auth()
const fb_storage = firebase.storage().ref()

// collection references
const fb_users = fb_db.collection('users')

// export utils/refs
export {
  fb_db,
  fb_auth,
  fb_storage,
  fb_users
}
